import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import CodeIcon from "@mui/icons-material/Code";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { LoaderScreen } from "../../components/LoaderScreen";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import AgregarPresentacionModal from "./AgregarPresentacionModal";
import EditarPresentacionModal from "./EditarPresentacionModal";
import CargarHtmlModal from "./CargarHtmlModal";

export const PresentacionesMainScreen = () => {
    const history = useHistory();
    const [presentaciones, setPresentaciones] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [openModalHtml, setOpenModalHtml] = useState(false);
    const [selectedPresentacion, setSelectedPresentacion] = useState(null);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get("Presentacion/Listado")
            .then((result) => {
                setPresentaciones(result);
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("PRESENTACIONES", JSON.stringify(error), "error");
            });
    }, [openModal, openModalEditar, openModalHtml]);

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const handleOpenModalEditar = (item) => {
        setSelectedPresentacion(item);
        setOpenModalEditar(true);
    };
    const handleCloseModalEditar = () => {
        setSelectedPresentacion(null);
        setOpenModalEditar(false);
    };

    const handleOpenModalHtml = (item) => {
        setSelectedPresentacion(item);
        setOpenModalHtml(true);
    };
    const handleCloseModalHtml = () => {
        setSelectedPresentacion(null);
        setOpenModalHtml(false);
    };

    const handleVerHtml = (htmlContenido) => {
        const blob = new Blob([htmlContenido], { type: "text/html" });
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
    };
    return (
        <PlantillaScreen
            titulo="PRESENTACIONES"
            className="presentaciones-main-screen"
            className_main={1}
        >
            <div className="presentaciones-actions">
                <div
                    className="presentaciones-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="buttons">
                    <button
                        className="presentaciones-btn-agregar"
                        onClick={handleOpenModal}
                    >
                        <AddCircleOutlineIcon /> Nueva Presentación
                    </button>
                </div>
            </div>

            <div className="presentaciones-container">
                <LoaderScreen loader={loader} />

                <div className="presentaciones-header">
                    <div className="presentaciones-header-title">
                        <FormatListNumberedIcon /> Listado de Presentaciones
                    </div>
                    <div className="presentaciones-header-contador">
                        Registros: {presentaciones.length}
                    </div>
                </div>

                <div className="presentaciones-container-tabla scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th><div className="borde-izq" style={{ color: "transparent" }}>.</div></th>
                                <th><div className="borde-izq">Nombre</div></th>
                                <th><div className="borde-izq">Descripción</div></th>
                            </tr>
                        </thead>
                        <tbody>
                            {presentaciones.map((item) => (
                                <tr key={item.presentacionId}>
                                    <td>
                                        <div className="presentaciones-acciones">
                                            <div
                                                className="presentaciones-btn-editar"
                                                onClick={() => handleOpenModalEditar(item)}
                                            >
                                                <EditIcon /> Editar
                                            </div>
                                            <div
                                                className="presentaciones-btn-html"
                                                onClick={() => handleOpenModalHtml(item)}
                                            >
                                                <CodeIcon /> Cargar HTML
                                            </div>
                                            {item.htmlContenido && item.htmlContenido.trim() !== "" && (
                                                <div
                                                    className="presentaciones-btn-ver"
                                                    onClick={() => handleVerHtml(item.htmlContenido)}
                                                >
                                                    <VisibilityIcon /> Ver
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                    <td>{item.nombre}</td>
                                    <td>{item.descripcion}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <AgregarPresentacionModal
                    open={openModal}
                    onClose={handleCloseModal}
                />
                <EditarPresentacionModal
                    open={openModalEditar}
                    onClose={handleCloseModalEditar}
                    presentacion={selectedPresentacion}
                />
                <CargarHtmlModal
                    open={openModalHtml}
                    onClose={handleCloseModalHtml}
                    presentacionId={selectedPresentacion?.presentacionId}
                />
            </div>
        </PlantillaScreen>
    );
};
